import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { getImageUrl } from '../utils/imageUrl';

const API_BASE = process.env.REACT_APP_API_URL;

export default function Gallery({ lang, t }) {
    const [allImages, setAllImages] = useState([]);
    const [fullscreenImg, setFullscreenImg] = useState(null);

    useEffect(() => {
        const fetchAll = async () => {
            let combined = [];
            // Fetch independently so one failure doesn't blank everything
            try { const p = await axios.get(`${API_BASE}/api/projects`); combined.push(...p.data.flatMap(item => item.images)); } catch (err) { console.error('Gallery projects fetch failed:', err); }
            try { const te = await axios.get(`${API_BASE}/api/technologies`); combined.push(...te.data.flatMap(item => item.images)); } catch (err) { console.error('Gallery tech fetch failed:', err); }
            setAllImages([...new Set(combined)]); // Remove duplicates
        };
        fetchAll();
    }, []);

    if (fullscreenImg) {
        return (
            <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center p-4 cursor-zoom-out" onClick={() => setFullscreenImg(null)}>
                <img src={getImageUrl(fullscreenImg, API_BASE)} crossOrigin="anonymous" referrerPolicy="no-referrer" className="max-w-full max-h-full shadow-2xl animate-zoomIn" alt="Gallery Full" />
                <button className="absolute top-10 right-10 text-white text-5xl">&times;</button>
            </div>
        );
    }

    return (
        <div className="animate-fadeIn pb-20">
            <Helmet>
                <title>Gallery — Alum Nawatha LTD | Aluminum Projects Portfolio</title>
                <meta name="description" content="Browse our gallery of premium aluminum projects — custom windows, curtain walls, facades and architectural aluminum solutions across Israel." />
            </Helmet>
            <div className="bg-slate-900 text-white py-20 text-center">
                <h1 className="text-5xl font-black uppercase mb-4">{t.gallery}</h1>
                <p className="text-blue-400 tracking-widest text-sm">{t.gallerySubtitle}</p>
            </div>

            <section className="container mx-auto px-6 py-16">
                <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
                    {allImages.map((img, idx) => (
                        <div
                            key={idx}
                            className="break-inside-avoid overflow-hidden rounded-xl cursor-zoom-in hover:opacity-90 transition-all duration-300"
                            onClick={() => setFullscreenImg(img)}
                        >
                            <img
                                src={getImageUrl(img, API_BASE)}
                                loading="lazy"
                                decoding="async"
                                crossOrigin="anonymous"
                                referrerPolicy="no-referrer"
                                width="400"
                                height="300"
                                className="w-full h-auto rounded-xl shadow-md border border-slate-100"
                                alt={`Gallery Item ${idx}`}
                                onError={(e) => {
                                    // Retry once with cache-bust for Safari/iPhone issues
                                    const src = e.target.src;
                                    if (!src.includes('_retry=1')) {
                                        e.target.src = src + (src.includes('?') ? '&' : '?') + '_retry=1';
                                    }
                                }}
                            />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}